import { RouteModule } from '#/horizon/components/RouteModule';
import { getServerRouterContext } from '#/horizon/router-contexts/server-router-context';
import type { LoaderDataWithOverrideLocale } from '#/horizon/utils/getMatchesOverrideLocale';
import { getI18n } from '#/i18n/getI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { salaryApiServerFetchCompensationSurvey } from '#/modules/salary/api/salaryApiGetCompensationSurvey';
import {
  salariesExploreRoute,
  salariesSurveyRoute,
} from '#/modules/salary/routing/salary.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { SalarySurveyPage } from './SalarySurveyPage';

export const handle = {
  variant: 'base',
} satisfies LayoutHandleProps;

export async function loader({
  request,
  url,
  context,
}: HorizonAppRouteLoaderArgs<typeof salariesSurveyRoute>) {
  const { serverContext } = getServerRouterContext(context);

  const { submittedTooManyTimes } =
    await salaryApiServerFetchCompensationSurvey({
      request,
      context,
    })();

  if (submittedTooManyTimes) {
    const { i18n } = getI18n(serverContext.locale);

    return idealistRedirect({
      fromUrl: url,
      context,
      to: salariesExploreRoute.with({}),
      flash: i18n(
        'We already have your survey information, but we love your enthusiasm!',
      ),
    });
  }

  return {
    overrideLocale: I18nLocale.EN,
  } satisfies LoaderDataWithOverrideLocale;
}

export default function SalarySurveyHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <RouteModule
      title="Idealist"
      ogImage={getStaticImageSrc('compdb/og-image.png')}
    >
      <SalarySurveyPage />
    </RouteModule>
  );
}
